module.exports = __webpack_public_path__ + "img/might-be-new-fixed-income.a9e2765e.svg";